var exports = {
  "offer-container": "xf0b3b88a--670255--offer-container",
  "outside-hidden": "xf0b3b88a--670255--outside-hidden",
  "represent": "xf0b3b88a--670255--represent",
  "offer-container--top3": "xf0b3b88a--670255--offer-container--top3",
  "offer--hide": "xf0b3b88a--670255--offer--hide",
  "offer--hidden": "xf0b3b88a--670255--offer--hidden",
  "photo-container": "xf0b3b88a--670255--photo-container",
  "photo": "xf0b3b88a--670255--photo",
  "footer-menu": "xf0b3b88a--670255--footer-menu",
  "footer-flags": "xf0b3b88a--670255--footer-flags",
  "hidden-base-label": "xf0b3b88a--670255--hidden-base-label",
};

module.exports = exports;
